/* eslint-disable import/no-named-as-default */
import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ProductListTable from '../ProductListTable';
import ProductEdit from '../ProductEdit';
import ProductCreate from '../ProductCreate';
import PriceEditPage from '../PriceEditPage';
import PriceCreatePage from '../PriceCreatePage';

export default function App() {
  return (
    <Router basename="/product">
      <Switch>
        <Route exact path="/" component={ProductListTable} />
        <Route exact path="/new" component={ProductCreate} />
        <Route exact path="/edit/:sku" component={ProductEdit} />
        <Route exact path="/edit/:sku/details" component={() => <ProductEdit tabKey="details" />} />
        <Route exact path="/edit/:sku/prices" component={() => <ProductEdit tabKey="prices" />} />
        <Route exact path="/edit/:sku/garages" component={() => <ProductEdit tabKey="garages" />} />
        <Route exact path="/edit/:sku/prices/:predefinedId" component={PriceEditPage} />
        <Route exact path="/edit/:sku/newPrice" component={PriceCreatePage} />
      </Switch>
    </Router>
  );
}
